// ---- PRODUCTS ----

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCTS = 'ADD_PRODUCTS';
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT';
export const SET_PRODUCT_VARIATION = 'SET_PRODUCT_VARIATION';
export const SET_CURRENT_PRODUCT_EDIT = 'SET_CURRENT_PRODUCT_EDIT';
export const SET_CURRENT_PRODUCT_RATINGS  = 'SET_CURRENT_PRODUCT_RATINGS ';
export const ADD_RATE = 'ADD_RATE';
export const SET_CURRENT_PRODUCT_PARENT = 'SET_CURRENT_PRODUCT_PARENT';
export const RESET_CURRENT_PRODUCT_PARENT = 'RESET_CURRENT_PRODUCT_PARENT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const SET_FEATUREDS = 'SET_FEATUREDS';
export const SET_SPECIALS = 'SET_SPECIALS';
export const SET_NEWS = 'SET_NEWS';
export const SET_RANDOMS = 'SET_RANDOMS';
export const RESET_RANDOMS = 'RESET_RANDOMS';

// ---- SHOPPING CART ----

export const SET_SHOPPING_CART_GUEST = 'SET_SHOPPING_CART_GUEST';
export const SET_SHOPPING_CART = 'SET_SHOPPING_CART';
export const SET_SHOPPING_ADDRESS = 'SET_SHOPPING_ADDRESS';
export const RESET_SHOPPING_ADDRESS = 'RESET_SHOPPING_ADDRESS';
export const SET_SHOPPING_SHIPPING = 'SET_SHOPPING_SHIPPING';
export const SET_SHOPPING_PAYMENT = 'SET_SHOPPING_PAYMENT';
export const SET_SHOPPING_INDEX = 'SET_SHOPPING_INDEX';
export const GET_HTML = 'GET_HTML';
export const ADD_LOCAL_SHOPPING_CART = 'ADD_LOCAL_SHOPPING_CART';
export const REMOVE_LOCAL_SHOPPING_CART = 'REMOVE_LOCAL_SHOPPING_CART';

// ---- USERS ----

export const SET_PROFILE_USER = 'SET_PROFILE_USER';
export const ADD_USERS = 'ADD_USERS';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const UNSET_CURRENT_USER = 'UNSET_CURRENT_USER';
export const UPDATE_ME = 'UPDATE_ME';

// ---- FAVOURITES ----

export const SET_WISH_LIST = 'SET_WISH_LIST';
export const ADD_PRODUCT_WISH_LIST = 'ADD_PRODUCT_WISH_LIST';
export const REMOVE_PRODUCT_WISH_LIST = 'REMOVE_PRODUCT_WISH_LIST';

// ---- BILLING INFO ----

export const SET_BILLING_INFO = 'SET_BILLING_INFO';
export const SET_RFC_BILLING_INFO = 'SET_RFC_BILLING_INFO';
export const ADD_BILLING_INFO = 'ADD_BILLING_INFO';
export const UPDATE_BILLING_INFO = 'UPDATE_BILLING_INFO';
export const SET_FEDEX_QUOTE = 'SET_FEDEX_QUOTE';
export const RESET_FEDEX_QUOTE = 'RESET_FEDEX_QUOTE';
export const SET_NATIONAL_QUOTE = 'SET_NATIONAL_QUOTE';
export const RESET_NATIONAL_QUOTE = 'RESET_NATIONAL_QUOTE';
export const REMOVE_BILLING_INFO = 'REMOVE_BILLING_INFO';

// ---- STATES ----

export const ADD_STATES = 'ADD_STATES';
export const ADD_CITIES = 'ADD_CITIES';

// ---- SEARCH ----

export const SET_RESULTS = 'SET_RESULTS';

// ---- ORDERS ----

export const GET_ORDERS = 'GET_ORDERS';
export const DELETE_ORDER = 'DELETE_ORDERS';
export const ADD_USER_PURCHASE_ORDERS = 'ADD_USER_PURCHASE_ORDERS';

// ---- SLIDERS ----

export const GET_SLIDERS = 'GET_SLIDERS';
export const GET_PUBLIC_SLIDERS = 'GET_PUBLIC_SLIDERS';
export const DELETE_SLIDER = 'DELETE_SLIDER';
export const ADD_NEW_SLIDER = 'ADD_NEW_SLIDER';

// ---- CATEGORIES ----

export const GET_CATEGORIES = 'GET_CATEGORIES';
export const SET_CURRENT_CATEGORY = 'SET_CURRENT_CATEGORY';

// ---- PROJECTS ----

export const GET_CONTRACT_PROJECTS = 'GET_CONTRACT_PROJECTS';
export const GET_PUBLIC_PROJECTS = 'GET_PUBLIC_PROJECTS';
export const ADD_CONTRACT_PROJECT = 'ADD_CONTRACT_PROJECT';
export const DELETE_CONTRACT_PROJECT = 'DELETE_CONTRACT_PROJECT';

// ---- PROMO CODES ----

export const SET_PROMO_CODE = 'SET_PROMO_CODE';

// ---- FILTERS ----

export const SET_FILTER_PRICE = 'SET_FILTER_PRICE';
export const SET_FILTER_SUBCATEGORY = 'SET_FILTER_SUBCATEGORY';
export const SET_FILTER_COLOR = 'SET_FILTER_COLOR';
export const RESET_FILTER_PRICE = 'RESET_FILTER_PRICE';

// ---- COLORS ----

export const SET_COLORS = 'SET_COLORS';
export const RESET_COLORS = 'RESET_COLORS';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js